module.exports = __webpack_public_path__ + "static/media/sharecard-slide-upload.5bf72608.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sharecard-slide-upload.png
// module id = 2133
// module chunks = 6